import {LocaleType} from "@/types/Locale.type";

export const mappedLocales: LocaleType[] = ["hr", 'en', 'de', 'cs', 'bs', 'es', 'it', 'pt', 'sr', 'fr', 'hu', 'nl', 'no', 'pl', 'sl', 'sv', 'en-gb', 'en-us', 'es-ar', 'es-mx', 'pt-br']